import React from 'react';

import { di } from 'react-magnetic-di';

import { Text } from '@atlaskit/primitives/compiled';

import { asFormNumberField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const ViewNumberInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formNumberField = asFormNumberField(formField);

	if (formNumberField === undefined) {
		return <></>;
	}

	return <Text testId={`field-input-number-view-${fieldId}`}>{formNumberField.value?.number}</Text>;
};
